import React, { createContext, useContext, useState, ReactNode } from 'react';

export type DashboardDateRange = 'current_pay_period' | 'last_closed_pay_period' | 'month_to_date' | 'last_30_days' | 'today';
export type DashboardTipType = 'total' | 'cash' | 'pos' | 'jar' | 'dispute';

interface DashboardFiltersContextType {
  dateRange: DashboardDateRange;
  setDateRange: (range: DashboardDateRange) => void;
  tipType: DashboardTipType;
  setTipType: (type: DashboardTipType) => void;
}

const DashboardFiltersContext = createContext<DashboardFiltersContextType | undefined>(undefined);

export const DashboardFiltersProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [dateRange, setDateRange] = useState<DashboardDateRange>('current_pay_period');
  const [tipType, setTipType] = useState<DashboardTipType>('total');

  return (
    <DashboardFiltersContext.Provider value={{ dateRange, setDateRange, tipType, setTipType }}>
      {children}
    </DashboardFiltersContext.Provider>
  );
};

export const useDashboardFilters = () => {
  const context = useContext(DashboardFiltersContext);
  if (!context) {
    throw new Error('useDashboardFilters must be used within a DashboardFiltersProvider');
  }
  return context;
};
